import { IonSpinner } from "@ionic/react";

export type SubscriptionPurchaseBackdropState = "processing" | "syncing" | "needsManualRetry";

interface SubscriptionPurchaseBackdropProps {
  isOpen: boolean;
  state: SubscriptionPurchaseBackdropState;
  onRetry?: () => void;
  onCancel?: () => void;
}

export const SubscriptionPurchaseBackdrop = ({
  isOpen,
  state,
  onRetry,
  onCancel,
}: SubscriptionPurchaseBackdropProps) => {
  if (!isOpen) {
    return null;
  }

  const isSyncing = state === "syncing";
  const showRetry = state === "needsManualRetry";

  return (
    <div
      className={`fixed inset-0 z-[12000] flex items-center justify-center transition-colors duration-300 ${
        isSyncing ? "bg-black/45" : "bg-black/70"
      }`}
    >
      <div className="mx-6 w-full max-w-[320px] px-6 py-5 text-center text-white">
        {showRetry ? (
          <>
            <p className="text-base font-semibold">We're syncing your purchase</p>
            <p className="mt-2 text-sm leading-relaxed text-white/90">
              This can take a moment. Tap "Try again" if it's taking too long.
            </p>
            <div className="mt-5 flex flex-col gap-3">
              <button
                type="button"
                onClick={onRetry}
                className="rounded-full bg-white px-6 py-3 text-sm font-semibold text-black"
              >
                Try again
              </button>
              <button
                type="button"
                onClick={onCancel}
                className="text-sm font-medium text-white/80"
              >
                Close
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="flex justify-center">
              <IonSpinner name="crescent" className="h-8 w-8 text-white" />
            </div>
            <p className="mt-4 text-base font-semibold">
              {isSyncing ? "Syncing your subscription..." : "Processing your subscription..."}
            </p>
            <p className="mt-2 text-sm leading-relaxed text-white/90">
              Please keep the app open and do not exit until this is complete.
            </p>
          </>
        )}
      </div>
    </div>
  );
};
